import React from "react";
import DatePicker from "react-datepicker";
import pickerCalendar from "../../assets/icons/picker-calendar.png";
import "../../styles/UI/childDatePicker.scss";

const ChildDatePicker = (props) => {
    const { placeholdeInfo, ...inputProps } = props;
    return (
        <div className="date-picker-group">
            <DatePicker
                {...inputProps}
            />
            <span className="date-picker-icon">
                <img className="pic" src={pickerCalendar} alt="Picker calendar Icon" />
            </span>
            <span className="date-picker-placeholder">{placeholdeInfo}</span>
        </div>
    )
};

export default ChildDatePicker;
